import 'vtt.js'

// Events are triggered and handles synchronously, this is not an async function
const parseCues = (webVTTContent) => {
  const parser = new window.WebVTT.Parser(window, window.WebVTT.StringDecoder())
  const errors = []
  const cues = []

  parser.oncue = function (cue) {
    cues.push(cue)
  }

  parser.onparsingerror = function (error) {
    errors.push(error)
  }

  parser.parse(webVTTContent)

  parser.flush()

  return { cues, errors }
}

export default parseCues
